var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1292,
    viewBox: "0 0 1440 1292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1440 0H0V475.129C-365.065 554.704 -606 691.543 -606 847C-606 1092.77 -3.823 1292 739 1292C1481.82 1292 2084 1092.77 2084 847C2084 686.21 1826.25 545.338 1440 467.144V0Z",
    fill: "url(#paint0_linear_2046_266)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2046_266",
    x1: 739,
    y1: 26,
    x2: 739,
    y2: 1024.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F0047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6100A5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion2);
export default __webpack_public_path__ + "static/media/Union2.d71dc17fb84712c6b3ca3c6fef076905.svg";
export { ForwardRef as ReactComponent };